import React from 'react';
import { Box, styled } from '@quillbot/design-system';

export const StyledBox = styled(Box)`
  && {
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
function QuillTabs({
  children,
  ...otherProps
}: {
  children: string | JSX.Element | JSX.Element[];
}) {
  return (
    <StyledBox
      {...otherProps}
      overflow={{ md: 'hidden', sm: 'auto', xs: 'auto' }}
      display="flex"
      mx="-8px"
      flexWrap="nowrap"
    >
      {children}
    </StyledBox>
  );
}

export default QuillTabs;
